import styled from "styled-components";
import { colors } from "src/theme/colors";
import { typography } from "src/theme";

export const Title = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey};
  margin-bottom: 18px;
`;

export const ReviewCardWrapper = styled.div`
  margin: 48px 0 35px;
  border-bottom: 1px solid ${colors.greyVeryLight};
`;

export const StarsAndLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 26px;
`;

export const Stars = styled.div``;

export const Label = styled.div`
  width: 74px;
  height: 38px;
  background-color: ${colors.mainLight};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: ${colors.grey};
`;

export const ReviewerDetails = styled.div`
  font-weight: 500;
  color: ${colors.grey};
  margin-bottom: 16px;
`;

export const Review = styled.div`
  font-size: 20px;
  color: ${colors.grey};
  line-height: 28px;
  font-weight: 500;
  margin-bottom: 24px;
`;
